import type { CitiesRepository } from "../../domain/repositories/CitiesRepository";
import type { Cities } from "../../domain/entities/Cities";

export const getCities = async (
  repo: CitiesRepository,
  stateId: string,
): Promise<Cities[]> => {
  return repo.getCities(stateId);
};